<template>
  <v-container style="padding-top:3rem;padding-bottom: 5rem; min-height: 100vh;  height: inherit;overflow-y: auto;">
    <v-form ref="form" lazy-validation>
      <v-row justify="center">
        <v-col class="d-flex flex-column" cols="12" sm="6">
          <div class="text-h5 font-weight-bold primary--text">
            {{ $t('verify.title') }}
            <!-- Certification number -->
          </div>
          <div class="desc-box text-subtitle-2">
            
            <span>{{ $t('verify.desc1') }}</span>
            <span>{{ $t('verify.desc2') }}</span>
            <span>{{ $t('verify.desc3') }}</span>
            
<!--             
            <span>The verification code has </span>
            <span>been sent as input information.</span>
            <span>Please enter the verification code.</span> -->

          </div>
          <v-text-field
            type="number"
            v-model="token"
            :error-messages="error"
            :rules="[rules.required]"
            class="my-4"
            clearable
            required
            v-on:keyup.enter="onSubmit"
            :label="$t('verify.codePlaceholder')"
          ></v-text-field>
          <v-text-field
            v-if="isFirst"
            type="text"
            v-model="recommend"
            class="my-4"
            clearable
            required
            :label="$t('verify.recommendPlaceholder')"
            v-on:keyup.enter="onSubmit"
          ></v-text-field>
 

          <v-checkbox
            v-if="isFirst"
            v-model="service"
            :error-messages="error"
            :rules="[rules.service]"
            :label="$t('verify.serviceTerms')"
            @click="onService"
          ></v-checkbox>          

          <v-checkbox
            v-if="isFirst"
            v-model="finance"
            :error-messages="error"
            :rules="[rules.finance]"
            :label="$t('verify.financeTerms')"
            @click="onFinance"
          ></v-checkbox>           

          <!-- <v-select :items="psiteList" v-model="psite" required label="매장">
          </v-select> -->
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col cols="6">
          <v-btn
            class="font-weight-bold"
            tile
            fixed
            x-large
            style="width:50%;z-index: 5;left: 0;bottom: 0px;height: 56px;"
            to="/signin"
          >
            돌아가기
          </v-btn>
        </v-col>
        <v-col cols="6"> -->
          <!-- {{ this.refer_code }} -->
        <v-btn
          class="font-weight-bold"
          color="primary"
          x-large
          block
          @click="onSubmit"
          :disabled="loading"
        >
          {{ $t('verify.loginBtn') }}
        </v-btn>

      <!-- </v-col>
      </v-row> -->
    </v-form>
 
    <v-dialog v-model="termsModal" persistent max-width="30rem">
          <v-card>
            <v-card-title   ></v-card-title>
            <v-card-text  >
              <div v-html="termsTxt" ></div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-0 primary" style ="">
              <v-btn
                color="#000000"
                
                
                width="100%"
                text
                x-large
                class="font-weight-bold"
                @click="termsModal = false"
              >
                {{ $t('verify.confirmBtn') }}
              </v-btn> 
               
            </v-card-actions>
          </v-card>
        </v-dialog> 

  </v-container>
</template>

<script>
export default {
  data: () => ({
    isFirst: false ,
    refer_code:null , 
    token: '',
    recommend: '',
    psite: '',
    psiteList: [],
    termsTxt:null , 
    termsModal : false , 
    service:false, 
    finance:false, 
    terms : null , 
    

    rules: {
      required: (value) => !!value || this.$t('verify.requiredCode') , 
      service: (value) => !!value || this.$t('verify.requiredService') , 
      finance: (value) => !!value || this.$t('verify.requiredFinance') 
    },
    error: ''
  }),
  computed: {
    loading() {
      return this.$store.getters.loading
    }
  },
  methods: {
    onService(){
      
      if( this.service ==  true ) {
        this.termsModal = true ;         
        this.termsTxt = this.terms.service ; 
      }
    } ,     
    onFinance(){
      
      if( this.finance ==  true ) {
        this.termsModal = true ;         
        this.termsTxt = this.terms.finance ; 
      }
    } , 

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.commit('loading', true)
        const params = {
          phone: this.$route.params.phone,
          token: this.token.trim(),
          recommend: this.recommend,
          psite: this.psite

        }
        this.$store
          .dispatch('LOGIN', params)
          .then((res) => {
            this.$store.commit('loading', false)
            if (!res) {
              throw new Error('no response')
            } else if (res.status) {
              // if (this.autoLogin) {
              //   localStorage.accessToken = res.token
              // }
              // this.$store.dispatch('FETCH_USERINFO').then((res) => {
              // this.$store.commit('loading', false)

              //   try {
              //     loginSuccess(this.email, res.token)
              //   } catch (error) {
              //     this.$store.commit('loading', false)
              //     console.log(error)
              //   }
              //   if (!res.data.user.auth_sms || res.data.user.auth_sms === 'N') {
              //     this.$router.push('/phone/verify')
              //     return
              //   }

              //   this.$store.commit('activeMenu', 'home')
              // })
              this.$cookies.remove('psite')
              this.$cookies.remove('recommend')
              this.$router.push('/home')
            } else if (res.code === 'token') {
              this.error = this.$t('verify.invalidToken')
            } else if (res.code === 'timeout') {
              this.error = this.$t('verify.tokenTimeout')
            }
          })
          .catch((err) => {
            this.error = this.$t('errorServer')
          })
      }
    }
  },
  created() {
    this.$store
      .dispatch('psite')
      .then((res) => {
        // console.log(res)
        if (res.data.result) {

          this.terms = res.data.terms  ;
          const data = res.data.data ; 
          

          this.psiteList = Object.keys(data).map((item) => ({
            text: data[item],
            value: item
          }))
        } else throw res
      })
      .catch((err) => {
        this.error = this.$t('errorServer')
      })

    if (!this.$route.params.phone) this.$router.replace('/signin')
    
    const psite = this.$cookies.get('psite')
    if (psite) this.psite = psite
    const recommend = this.$cookies.get('recommend')
    if (recommend) this.recommend = recommend ; 


    if( this.$route.params.firstLogin == true)  {
      this.isFirst = true  
    } else{ 
      this.finance = true ; 
      this.service = true ;    
    } ;

    // this.refer_code =  this.$cookies.get('refer_code')  ;     
    // console.log("refer_code ::?? "  ,  this.$cookies.get('refer_code') )
  }
}
</script>

<style>
.desc-box {
  background-color: #f1f1f1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  margin: 1rem 0;
}
</style>
